<template>
  <div class="m_footer">
    <p>©2016 内蒙古奥云信息技术服务有限公司 版权所有</p>
    <p> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001520" style="display:inline-block; color:inherit;margin: 0 10px;"   target="_blank">
      <img src="../../assets/images/baImg.png">蒙公网安备 15010502001520号</a>
      <a style="color: inherit;" href="http://beian.miit.gov.cn/"   target="_blank">蒙ICP备18000606号-1</a></p>
  </div>
</template>
<script>

export default {
  name: 'm_footer'

}
</script>
<style lang="scss" scoped>
.pageContainer {

}
</style>



// WEBPACK FOOTER //
// src/components/mobileFooter/index.vue